import { z } from 'zod';
export const CollectionSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
    name: z.string().min(1).max(100),
    description: z.string().max(500).nullable(),
    emoji: z.string().max(8),
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).nullable(),
    bookIds: z.array(z.string().uuid()),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateCollectionInputSchema = z
    .object({
    name: z.string().trim().min(1).max(100),
    description: z.string().trim().max(500).optional(),
    emoji: z.string().min(1).max(8),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, 'Couleur hex invalide')
        .optional(),
    bookIds: z.array(z.string().uuid()).max(1000).default([]),
})
    .strict();
export const UpdateCollectionInputSchema = CreateCollectionInputSchema.partial();
//# sourceMappingURL=collection.schema.js.map